// extracted by mini-css-extract-plugin
module.exports = {"nestedMsg":"styles_nestedMsg__mQC31","container":"styles_container__KwUhH","scrollable":"styles_scrollable___Xrsh"};